import React, { useContext } from 'react';
import { CartContext } from '@repo/contexts/CartContext';
import { MdOutlineShoppingCart } from 'react-icons/md';
import { useUiComponentsInternationalContext } from '@repo/static-translations';
import { Button } from '@repo/ui-components/shadcn/Button';

function CartIcon(): JSX.Element {
  const { cart, cartActive, cartTriggerRef, setCartActive } =
    useContext(CartContext);
  const { tt } = useUiComponentsInternationalContext();

  return (
    <Button
      variant="link"
      title={tt(s => s.headerCommon.cartIconTitle)}
      aria-label={
        (cart?.totalQuantity ?? 0) === 1
          ? tt(s => s.headerCommon.cartAriaLabel, {
              numberOfItems: (cart?.totalQuantity ?? 0).toString(),
            })
          : tt(s => s.headerCommon.cartAriaLabelPlural, {
              numberOfItems: (cart?.totalQuantity ?? 0).toString(),
            })
      }
      onClick={e => {
        e.preventDefault();
        cartTriggerRef.current = e.currentTarget;
        setCartActive(!cartActive);
      }}
      data-cart-trigger
      className="group relative flex h-10 w-10 cursor-pointer items-center justify-center rounded-sm ml-1 hover:bg-iconButtonBackgroundHover"
    >
      <div className="flex flex-1 items-center justify-center">
        <MdOutlineShoppingCart
          size={28}
          className="transition-colors duration-500 fill-iconButtonFill  group-hover:fill-iconButtonFill"
        />
      </div>
      {cart?.totalQuantity > 0 && (
        <div className="absolute right-[-2px] top-[-2px] flex h-[17px] w-[17px] items-center justify-center rounded-full bg-badge-background text-[0.625rem] font-normal text-white">
          {cart.totalQuantity}
        </div>
      )}
    </Button>
  );
}

export default CartIcon;
